import { setup, assign, fromPromise } from 'xstate';
import axios from '../../axiosConfig';
import {
  Context,
  Event,
  State,
  EventType,
  submitEvent,
  SignupSubmission,
} from './selfServeSignup.fsm.types';
import { AxiosError } from 'axios';

const MACHINE_ID = 'SelfServeSignupFSM';

export const selfServeSignupFSM = setup({
  types: {
    context: {} as Context,
    events: {} as Event,
  },
  actors: {
    submitSignup: fromPromise(
      async ({ input }: { input: SignupSubmission }) => {
        const res = await axios.post('/api/self-serve/signup', input);
        return res;
      },
    ),
  },
}).createMachine({
  id: MACHINE_ID,
  initial: State.INITIAL,
  context: {
    isLoading: false,
    error: undefined,
    checkoutUrl: null,
  },
  states: {
    [State.INITIAL]: {
      on: {
        [EventType.SUBMIT]: {
          target: State.SUBMITTING,
          actions: assign({ isLoading: true, error: undefined }),
        },
      },
    },
    [State.SUBMITTING]: {
      invoke: {
        src: 'submitSignup',
        input: ({ event }) => (event as submitEvent).payload,
        onDone: {
          target: State.SUBMITTED,
          actions: assign({
            isLoading: false,
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
            checkoutUrl: ({ event }) => (event.output as any).data.checkoutUrl,
          }),
        },
        onError: {
          target: State.ERROR,
          actions: assign({
            isLoading: false,
            error: ({ event }) => event.error as AxiosError,
          }),
        },
      },
    },
    // Terminal from the calling page's point of view: the account page
    // redirects the whole browser to Stripe Checkout on seeing this, which
    // unmounts the machine instance.
    [State.SUBMITTED]: {},
    [State.ERROR]: {
      after: {
        200: {
          target: State.INITIAL,
        },
      },
    },
  },
});
